import {updateFactory} from '@modifi/redux'
import {getAuthenticatedAdminAresClient} from '@modifi/trade-api-clients'

const client = getAuthenticatedAdminAresClient()

const {actions, selectors, reducer} = updateFactory({
  rootSelector: state => state?.modules?.passThroughTransaction,
  actionNamePrefix: `transactions/pass-through-transaction`,
  submitRequest:
    (a, params) =>
    async (dispatch): Promise<void> => {
      const {transactionId, ...changes} = params
      dispatch(a.pendingAction())
      try {
        await client.BankTransactions.markAsPassThrough({
          transactionId,
          body: changes,
        }).then(res => res.data())
      } catch (e) {
        dispatch(a.errorAction(e))
        throw e
      }
      dispatch(a.successAction())
    },
})

export default reducer

export const {
  selectUpdateErrorMessage: selectPassThroughErrorMessage,
  selectUpdatePending: selectPassThroughPending,
} = selectors

export const {aSubmit: aPassThroughTransaction, aReset: aCleanupPassThrough} = actions
